import { Button } from '@/components/ui/button';
import { SupportPage } from '@/pages/constants';

/**
 * Last-resort screen for the root error boundary. It renders outside the router
 * and outside every provider, so it stays self-contained and links with a plain
 * anchor — a full page load is the point when the app tree is already broken.
 */
export default function AppErrorFallback() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4">
            <div className="flex w-full max-w-md flex-col items-center gap-4 text-center">
                <h1 className="text-xl font-semibold text-foreground">
                    Não foi possível carregar a página
                </h1>
                <p className="text-sm text-muted-foreground">
                    Recarregue para tentar de novo. Seus laudos e pacientes continuam salvos.
                </p>
                <Button onClick={() => window.location.reload()}>Recarregar página</Button>
                <a
                    href={`/${SupportPage}`}
                    className="text-sm text-muted-foreground underline underline-offset-4 hover:text-foreground"
                >
                    Falar com o suporte
                </a>
            </div>
        </div>
    );
}
